
import { defineComponent } from 'vue'
import { iSchedulation, iGroupDataItem, iDisplayMode } from './SchedulationAgenda'
import DataTable from 'primevue/datatable'
import Badge from 'primevue/badge'
import Column from 'primevue/column'
import SelectButton from 'primevue/selectbutton'
import schedulationAgendaDescriptor from './SchedulationAgendaDescriptor.json'
import { formatDate, getLocale, formatDateWithLocale } from '@/helpers/commons/localeHelper'
import Card from 'primevue/card'
import moment from 'moment'

export default defineComponent({
    name: 'schedulation-agenda-display',
    components: {
        Card,
        Badge,
        Column,
        DataTable,
        SelectButton
    },
    props: {
        itemList: Array
    },
    data() {
        return {
            selectedItem: {},
            displayMode: 'time',
            expandedRows: [],
            schedulationAgendaDescriptor,
            dataItemList: [] as iSchedulation[],
            groupedItemList: [] as iGroupDataItem[],
            colorDictionary: {},
            selectedDisplayMode: null as iDisplayMode | null,
            displayModes: [
                { name: this.$t('managers.schedulationAgendaManagement.detail.time'), code: 'time' },
                { name: this.$t('managers.schedulationAgendaManagement.detail.package'), code: 'package' },
                { name: this.$t('managers.schedulationAgendaManagement.detail.document'), code: 'document' }
            ]
        }
    },
    watch: {
        itemList() {
            this.dataItemList = this.itemList as iSchedulation[]
            if (this.displayMode) {
                this.updateDisplayData(this.displayMode)
            }
        },
        selectedDisplayMode() {
            if (this.selectedDisplayMode) {
                this.displayMode = this.selectedDisplayMode.code
                this.updateDisplayData(this.displayMode)
            }
        }
    },
    methods: {
        getLocale(js) {
            getLocale(js)
        },
        updateDisplayData(displayType: string) {
            this.runDisplay(displayType)
        },
        runDisplay(displayType: string) {
            this.groupedItemList = [] as iGroupDataItem[]
            this.displayMode = displayType
            switch (displayType) {
                case 'time':
                    this.groupedItemList = this.createTimeItemList()
                    break
                case 'package':
                    this.groupedItemList = this.createPackageItemList()
                    break
                case 'document':
                    this.groupedItemList = this.createDocumentItemList()
                    break
            }
        },
        openRedirection(jobName: String) {
            if (jobName) {
                this.$router.push(`/scheduler/edit-package-schedule?id=${jobName}&clone=false`)
            }
        },
        getRandomColor(inputName: any) {
            let currentColor = this.colorDictionary[inputName]
            if (!currentColor) {
                var letters = '0123456789ABCDEF'
                var color = '#'
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)]
                }
                currentColor = color
                this.colorDictionary[inputName] = currentColor
            }
            return currentColor
        },
        createDocumentItemList(): iGroupDataItem[] {
            let index = 0
            const groupedItemList: iGroupDataItem[] = []
            for (let i = 0; i < this.dataItemList.length; i++) {
                if (this.dataItemList[i].triggers && this.dataItemList[i].triggers[0].executions) {
                    for (let j = 0; j < this.dataItemList[i].triggers.length; j++) {
                        for (let k = 0; k < this.dataItemList[i].triggers[j].executions.length; k++) {
                            for (let l = 0; l < this.dataItemList[i].triggers[j].documents.length; l++) {
                                let item = groupedItemList.find((x) => x.document === this.dataItemList[i].triggers[j].documents[l])
                                if (!item) {
                                    item = {
                                        jobName: '',
                                        color: 'red',
                                        document: this.dataItemList[i].triggers[j].documents[l],
                                        executions: [] as any
                                    }
                                    groupedItemList.push(item)
                                }

                                let execution = item.executions.find((x) => x.date == new Date(this.dataItemList[i].triggers[j].executions[k]))

                                if (!execution) {
                                    execution = {
                                        id: index++,
                                        date: this.formatDateTime(this.dataItemList[i].triggers[j].executions[k]),
                                        jobName: this.dataItemList[i].triggers[j].jobName,
                                        numberOfDocuments: this.dataItemList[i].triggers[j].documents.length,
                                        documents: this.dataItemList[i].triggers[j].documents
                                    }
                                    item.executions.push(execution)
                                }
                            }
                        }
                    }
                }
            }
            return groupedItemList
        },
        createPackageItemList(): iGroupDataItem[] {
            let index = 0
            const groupedItemList: iGroupDataItem[] = []
            for (let i = 0; i < this.dataItemList.length; i++) {
                if (this.dataItemList[i].triggers && this.dataItemList[i].triggers[0].executions) {
                    let item = {
                        jobName: this.dataItemList[i].name,
                        color: 'red',
                        document: '',
                        executions: [] as any
                    }
                    for (let j = 0; j < this.dataItemList[i].triggers.length; j++) {
                        for (let k = 0; k < this.dataItemList[i].triggers[j].executions.length; k++) {
                            let execution = {
                                id: index++,
                                rawDate: new Date(this.dataItemList[i].triggers[j].executions[k]),
                                date: this.formatDateTime(this.dataItemList[i].triggers[j].executions[k]),
                                jobName: this.dataItemList[i].triggers[j].jobName,
                                numberOfDocuments: this.dataItemList[i].triggers[j].documents.length,
                                documents: this.dataItemList[i].triggers[j].documents
                            }
                            const executionMomentDate = moment(execution.rawDate)
                            const ind = item.executions.findIndex((item) => executionMomentDate.isBefore(item.rawDate))
                            if (ind >= 0) {
                                item.executions.splice(ind, 0, execution)
                            } else {
                                item.executions.push(execution)
                            }
                        }
                    }
                    groupedItemList.push(item)
                }
            }
            return groupedItemList
        },
        createTimeItemList(): iGroupDataItem[] {
            let index = 0
            const groupedItemList: iGroupDataItem[] = []
            for (let i = 0; i < this.dataItemList.length; i++) {
                if (this.dataItemList[i].triggers && this.dataItemList[i].triggers[0].executions) {
                    for (let j = 0; j < this.dataItemList[i].triggers.length; j++) {
                        for (let k = 0; k < this.dataItemList[i].triggers[j].executions.length; k++) {
                            let item = groupedItemList.find((x) => moment(x.date).isSame(this.dataItemList[i].triggers[j].executions[k], 'day'))
                            if (!item) {
                                item = this.createTimeGrupItem(this.dataItemList[i].triggers[j].executions[k])
                                //search for position of group item
                                const itemMomentDate = moment(item.rawDate)
                                const ind = groupedItemList.findIndex((groupItem) => itemMomentDate.isBefore(groupItem.rawDate))
                                if (ind >= 0) {
                                    groupedItemList.splice(ind, 0, item)
                                } else {
                                    groupedItemList.push(item)
                                }
                            }
                            let execution = {
                                id: index++,
                                rawDate: new Date(this.dataItemList[i].triggers[j].executions[k]),
                                date: this.dataItemList[i].triggers[j].executions[k],
                                jobName: this.dataItemList[i].triggers[j].jobName,
                                numberOfDocuments: this.dataItemList[i].triggers[j].documents.length,
                                documents: this.dataItemList[i].triggers[j].documents
                            }
                            const execItemMomentDate = moment(execution.rawDate)
                            const execItemInd = item.executions.findIndex((groupItem) => execItemMomentDate.isBefore(groupItem.rawDate))
                            if (execItemInd >= 0) {
                                item.executions.splice(execItemInd, 0, execution)
                            } else {
                                item.executions.push(execution)
                            }
                        }
                    }
                }
            }
            return groupedItemList
        },
        createTimeGrupItem(date: string) {
            return {
                jobName: '',
                color: 'red',
                rawDate: new Date(date),
                date: formatDateWithLocale(date),
                dayOfWeek: formatDateWithLocale(date, { weekday: 'long' }),
                monthName: formatDateWithLocale(date, { month: 'long' }),
                year: new Date(date).getFullYear(),
                day: new Date(date).getDate(),
                document: '',
                executions: [] as any
            }
        },
        returnTime(inputDate: any) {
            var date = new Date(inputDate)
            if (date) {
                return date.toLocaleTimeString(navigator.language, {
                    hour: '2-digit',
                    minute: '2-digit'
                })
            }
        },
        formatDateTime(date: any) {
            return formatDate(date, 'DD/MM/YYYY HH:MM')
        }
    }
})
